<template>
    <div class="w-full mt-6">
        <label class="text-body-6 font-medium">
          Click below to copy link
        </label>
        <div class="w-full relative mt-2">
            <input
                :value="shareLink"
                type="text"
                readonly
                class="cursor-pointer block w-full xxs:h-12 lg:h-10 text-body-6 font-normal text-default-1 rounded border border-interactive-9 focus:outline-none focus:ring-0"
                @click="copyToClipboard"
            />
            <p class="text-body-7 text-left text-default-2 mt-2">
                Copy link to paste in an email, SMS or to use to link to a document from a resource<br>
                * Permissions must be set first for any member or group of members to access it
            </p>

            <transition enter-active-class="transition ease-out duration-100"
                        enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75"
                        leave-from-class="transform opacity-100 scale-100"
                        leave-to-class="transform opacity-0 scale-95">
                <div
                    class="text-white bg-default-5 rounded rounded-1 text-body-7 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-2 py-1"
                    v-if="copiedToClipboard"
                >Copied to clipboard</div>
            </transition>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";

const props = defineProps({
    document: {
        type: Object,
        default: () => {},
        required: true,
    }
})

const copiedToClipboard = ref(false);
const shareLink = ref('');

function copyToClipboard() {
    navigator.clipboard.writeText(shareLink.value);

    copiedToClipboard.value = true;
    setTimeout(() => {
        copiedToClipboard.value = false;
    }, 1500);
}

onMounted(() => {
    let typeOf;
    let uid;

    if ('documentable_type' in props.document && props.document.documentable_type === 'folder') {
        typeOf = 'f';
        uid = props.document.documentable?.uid;
    } else {
        typeOf = 'd';
        uid = props.document.uid;
    }

    shareLink.value = `${window.location.origin}/documents/${typeOf}/${uid}`;
})
</script>